import { FC, useEffect, useState } from "react";
import { Tender, Tendering } from "../../../models/tendering";
import {
  Button,
  Spinner,
  Subtitle2,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Tooltip,
} from "@fluentui/react-components";
import { EditRegular } from "@fluentui/react-icons";
import { getUsersByModule } from "../../../services/usersService";
import UserDrawer from "../../drawers/UserDrawer";
import { User } from "../../../models/users";

interface TenderPermissionsProps {
  tenderDocument: Tender;
  tenderingDocument: Tendering;
}

const TenderPermissions: FC<TenderPermissionsProps> = (props) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState<boolean>(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const result = await getUsersByModule(props.tenderDocument.tenderID);
        const mapped: User[] = result.map((item: any) => item.user ?? item);
        setUsers(mapped);
      } catch (error) {
        console.error("Error fetching module users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [props.tenderDocument.tenderID]);

  const openDrawer = (user: User) => {
    setSelectedUser(user);
    setIsUserDrawerOpen(true);
  };

  const handleUserUpdated = (updatedUser: User) => {
    setUsers((prev) =>
      prev.map((u) => (u.userID === updatedUser.userID ? updatedUser : u))
    );
  };

  if (loading) {
    return <Spinner className="mt-10" size="huge" label="Laddar..." />;
  }

  return (
    <>
      <Table size="extra-small">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <Subtitle2>Namn</Subtitle2>
            </TableHeaderCell>
            <TableHeaderCell>
              <Subtitle2>E-post</Subtitle2>
            </TableHeaderCell>
            <TableHeaderCell />
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.userID}>
              <TableCell>
                {user.firstName} {user.lastName}
              </TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>
                <Tooltip content="Redigera" relationship="label">
                  <Button
                    shape="circular"
                    icon={<EditRegular />}
                    onClick={() => openDrawer(user)}
                  >
                  </Button>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {selectedUser && (
        <UserDrawer
          open={isUserDrawerOpen}
          onClose={() => setIsUserDrawerOpen(false)}
          user={selectedUser}
          organizations={[]}
          onUserUpdated={handleUserUpdated}
        />
      )}
    </>
  );
};

export default TenderPermissions;
